import { render, staticRenderFns } from "./resourceTools.vue?vue&type=template&id=dd713fd4&scoped=true"
import script from "./resourceTools.vue?vue&type=script&lang=js"
export * from "./resourceTools.vue?vue&type=script&lang=js"
import style0 from "./resourceTools.vue?vue&type=style&index=0&id=dd713fd4&prod&lang=css"
import style1 from "./resourceTools.vue?vue&type=style&index=1&id=dd713fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd713fd4",
  null
  
)

export default component.exports